import moment from 'moment-mini';
import { getVideoTimestampByUrl } from 'root/src/client/util/getVideoTimestampByUrl';
// Resolves the start offset (seconds) for a delivered clip, mirroring the legacy Player's
// `start = params?.start || timestamp || getVideoTimestampByUrl(videoURL)`: prefer the explicit
// params.start, then the stored HH:mm:ss timeStamp, then any `?t=` on the video URL. Returns 0 when
// none apply (so the embed starts from the beginning).
export const getDeliveryStartSeconds = (delivery) => {
    var _a;
    const paramsStart = (_a = delivery.params) === null || _a === void 0 ? void 0 : _a.start;
    if (paramsStart) {
        const parsed = Number(paramsStart);
        if (!Number.isNaN(parsed) && parsed > 0) {
            return parsed;
        }
    }
    if (delivery.timeStamp && delivery.timeStamp !== '00:00:00') {
        const seconds = moment.duration(delivery.timeStamp).asSeconds();
        if (seconds > 0) {
            return Math.floor(seconds);
        }
    }
    if (delivery.videoURL) {
        try {
            const fromUrl = getVideoTimestampByUrl(delivery.videoURL);
            if (typeof fromUrl === 'number' && fromUrl > 0) {
                return fromUrl;
            }
        }
        catch (_b) {
            return 0;
        }
    }
    return 0;
};
